import React from "react";
import useAuth from "../../hooks/useAuth";
import { isMenuItemVisible } from "../../utils/authTools";
import SidebarNavList from "./SidebarNavList";

const SidebarNavSection = (props) => {
  const {
    pages,
    bottom,
    className,
    component: Component = "nav",
    ...rest
  } = props;
  const [{ state }] = useAuth();
  const { routes } = state;

  // const mainPages = pages.filter(
  //   (page) => !page?.bottom && isMenuItemVisible(page?.title, routes)
  // );
  // const bottomPages = pages.filter(
  //   (page) => page?.bottom && isMenuItemVisible(page?.title, routes)
  // );

  const visiblePages = pages.filter((page) =>
    isMenuItemVisible(page?.title, routes)
  );

  return (
    <Component {...rest}>
      <SidebarNavList pages={visiblePages} depth={0} />
    </Component>
  );
};

export default SidebarNavSection;
